import React from 'react'
import { useTranslation } from 'react-i18next'
import './experience.css'
import {
  SiCsharp,
  SiDotnet,
  SiJava,
  SiPython,
  SiJavascript,
  SiTypescript,
  SiLaravel,
  SiWordpress,
  SiAngular,
  SiReact,
  SiNodedotjs,
  SiVuedotjs,
  SiHtml5,
  SiCss3,
  SiBootstrap,
  SiTailwindcss,
  SiIonic,
  SiFlutter,
  SiMysql,
  SiMongodb,
  SiMicrosoft,
} from 'react-icons/si'
import { TbApiApp } from 'react-icons/tb'
import { FiDatabase, FiLayers } from 'react-icons/fi'

const techStack = [
  {
    categoryKey: 'languages',
    items: [
      { name: 'C#', icon: SiCsharp, color: '#9b4f96' },
      { name: 'VB.NET', icon: SiMicrosoft, color: '#512bd4' },
      { name: 'Java', icon: SiJava, color: '#f89820' },
      { name: 'Python', icon: SiPython, color: '#3776ab' },
      { name: 'JavaScript', icon: SiJavascript, color: '#f7df1e' },
      { name: 'TypeScript', icon: SiTypescript, color: '#3178c6' },
    ],
  },
  {
    categoryKey: 'frameworks',
    items: [
      { name: '.NET', icon: SiDotnet, color: '#512bd4' },
      { name: '.NET Core', icon: SiDotnet, color: '#512bd4' },
      { name: 'ASP.NET', icon: SiDotnet, color: '#512bd4' },
      { name: 'MVC', icon: FiLayers, color: '#a78bfa' },
      { name: 'Laravel', icon: SiLaravel, color: '#ff2d20' },
      { name: 'WordPress', icon: SiWordpress, color: '#21759b' },
    ],
  },
  {
    categoryKey: 'frontend',
    items: [
      { name: 'Angular', icon: SiAngular, color: '#dd0031' },
      { name: 'React', icon: SiReact, color: '#61dafb' },
      { name: 'Node.js', icon: SiNodedotjs, color: '#339933' },
      { name: 'Vue.js', icon: SiVuedotjs, color: '#4fc08d' },
      { name: 'HTML', icon: SiHtml5, color: '#e34f26' },
      { name: 'CSS', icon: SiCss3, color: '#1572b6' },
      { name: 'Bootstrap', icon: SiBootstrap, color: '#7952b3' },
      { name: 'Tailwind', icon: SiTailwindcss, color: '#06b6d4' },
    ],
  },
  {
    categoryKey: 'mobile',
    items: [
      { name: 'Ionic', icon: SiIonic, color: '#3880ff' },
      { name: 'Flutter', icon: SiFlutter, color: '#02569b' },
      { name: 'React Native', icon: SiReact, color: '#61dafb' },
    ],
  },
  {
    categoryKey: 'data',
    items: [
      { name: 'SQL', icon: FiDatabase, color: '#cc2927' },
      { name: 'MySQL', icon: SiMysql, color: '#4479a1' },
      { name: 'MongoDB', icon: SiMongodb, color: '#47a248' },
      { name: 'Web API', icon: TbApiApp, color: '#8b5cf6' },
      { name: 'WCF', icon: SiMicrosoft, color: '#00a4ef' },
    ],
  },
]

const Experience = () => {
  const { t } = useTranslation()

  return (
    <section id="technologies" className="tech-section">
      <div className="tech-section__glow" />
      <div className="container">
        <div className="section__header">
          <span className="section__label">{t('technologies.subtitle')}</span>
          <h2 className="section__title">{t('technologies.title')}</h2>
        </div>

        <div className="tech__stack">
          {techStack.map(({ categoryKey, items }) => (
            <div key={categoryKey} className="tech__block">
              <h3 className="tech__category">{t(`technologies.${categoryKey}`)}</h3>
              <div className="tech__items">
                {items.map(({ name, icon: Icon, color }) => (
                  <div
                    key={name}
                    className="tech__item glass"
                    style={{ '--tech-color': color }}
                  >
                    <div className="tech__icon">
                      <Icon />
                    </div>
                    <span>{name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Experience
